import { gql } from '@apollo/client';
import Fragments from './fragments';

export const USER_QUERY = gql`
  query user($id: Int!) {
    user(id: $id) {
      ...user
    }
  }
  ${Fragments.user}
`;

export const PERSON_LIST_QUERY = gql`
  query personList($search: String) {
    personList(search: $search) {
      id
      name
    }
  }
`;

export const PARTNER_LIST_QUERY = gql`
  query partnerList($search: String) {
    partnerList(search: $search) {
      id
      name
    }
  }
`;
